import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import UCSColors from "@ucs/Utils/UCSColors";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface ProductListFiltersAccordionStyles {
    accordion?: AccordionPresentationProps;
}

export const filtersAccordionStyles: ProductListFiltersAccordionStyles = {
    accordion: {
        css: css`
            padding-top: 20px;
            border-bottom: 2px solid ${UCSColors.gray08};
            && dt,
            && dd,
            && button,
            && span {
                border-color: ${UCSColors.gray08};
                border-width: 2px;
                color: ${UCSColors.gray04};
                background: transparent;
                padding-left: 0;
                font-size: 13px;
                text-transform: uppercase;
                &:focus {
                    padding-left: 0;
                    border-color: ${UCSColors.gray08};
                    border-width: 2px;
                }
            }
            && dd {
                padding-top: 0;
                margin-top: -12px;
                text-transform: capitalize;
            }
            && button {
                padding-top: 7px;
                padding-bottom: 25px;
                &:focus {
                    padding-top: 7px;
                    padding-bottom: 25px;
                }
            }
        `,
    },
};

const styles = filtersAccordionStyles;

const ProductListFiltersAccordion: FC<Props> = ({ id }) => {
    return (
        <Accordion headingLevel={2} {...styles.accordion}>
            <Zone contentId={id} zoneName="Content" />
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFiltersAccordion,
    definition: {
        group: "Product List",
        displayName: "Filters Accordion",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
